import { createFileRoute } from "@tanstack/react-router";

import { ContentArchiveIndex } from "@/components/content-archive-index";
import { pageSeo } from "@/lib/seo";

export const Route = createFileRoute("/content/")({
  head: () => ({
    ...pageSeo({
      path: "/content",
      title: "Content Archive | CRS Energy",
      description: "Internal archive of copy removed or superseded from live pages.",
    }),
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
  component: ContentArchiveIndex,
});
